"use strict";

var accomodationsList = function () {
  function unbindHandlers() {
    $(document).off('click', '.accomodation-archive');
  }

  function bindHandlers() {
    $(document).on('click', '.accomodation-archive', function () {
      if ($(this).hasClass('-expanded')) {
        $(this).removeClass('-expanded');
        $(this).find('.link.-more').text('Показать архивные');
      } else {
        $(this).addClass('-expanded');
        $(this).find('.link.-more').text('Скрыть архивные');
      }

      $('.accomodation-list.-archive').toggleClass('-shown');
    });
  }

  function init() {
    unbindHandlers();
    bindHandlers();
  }

  return {
    init: init
  };
}();